<template>
  <div class="repay-result">
    <!-- 只是为了兼容在APP内的情况 -->
    <navigation adaption />

    <pulldown-page class="pull-down" :refresh="pulldown" background="white" color="#333333">
      <div class="call" @click="openCallDialog" v-if="platform.showTitle">
        <img src="../../assets/images/call.png" />
        <span class="contact">联系客服</span>
      </div>

      <template v-if="repayResult.haveRepayConsumptionBill && gvipRepayPopupShow === 'N'">
        <div class="haveRepayConsumptionBill">
          <span class="back" @click="backHome">返回首页</span>
          <h2>{{ platform.name }}</h2>
          <p>您于{{ repayResult.realRepayTime | date}}日提交的还款申请已成功，金额￥{{ repayResult.realTotalAmt | currency }}元，订单状态稍后更新，请留意查看</p>
          <div class="tips">
            <i class="bell"></i>
            <h3>温馨提示</h3>
            <p>您有大权益的消费分期账单待支付，为避免影响您的平台综合信用，请您及时支付！</p>
            <nd-button class="btn" @click="check">立即查看</nd-button>
          </div>
        </div>
      </template>

      <template v-else>
        <!-- 线上还款 -->
        <div class='repay-status' v-if="type === 'online'">
          <div class="animation-wapper" v-if="showGif">
            <lottie ref="animataion" :options="showGif" v-on:animCreated="handleAnimation" />
          </div>
          <p class="status-title">{{ platform.name }}</p>
          <div class="status-description">
            <p v-for="(des, index) in platform.des" :key="index">{{ des }}</p>
          </div>

          <div class="bill-info" v-if="repayStatus === 'SUCCESS'">
            <div class="item">
              <p class="title">还款金额</p>
              <p class="content number">￥{{ repayResult.realTotalAmt | currency }}</p>
            </div>
            <div class="item">
              <p class="title">还款日期</p>
              <p class="content number">{{ repayResult.realRepayTime | date}}</p>
            </div>
            <div class="item">
              <p class="title">还款平台</p>
              <p class="content">天美贷</p>
            </div>
            <!-- <div class="item">
                        <p  class="title">订单编号</p>
                        <p  class="content number">{{ repayResult.orderId }}</p>
                    </div> -->
          </div>
          <div class="bill-info" v-else-if="repayStatus === 'PART'">
            <div class="item">
              <p class="title">已还款金额</p>
              <p class="content number">￥{{ repayResult.realTotalAmt | currency }}</p>
            </div>
            <div class="item">
              <p class="title">待还款金额</p>
              <p class="content number">￥{{ repayResult.crRepayTotalAmt | currency }}</p>
            </div>
            <div class="item">
              <p class="title">还款日期</p>
              <p class="content number">{{ repayResult.realRepayTime | date}}</p>
            </div>
            <div class="item">
              <p class="title">还款平台</p>
              <p class="content">天美贷</p>
            </div>
          </div>
          <guideWithdraw v-if="['IN_PROGRESS','SUCCESS'].includes(repayResult.repayStatus)" :status="repayResult.repayStatus"></guideWithdraw>
          <!-- api 老用户 用户引导关注的 banner -->
          <div class="guideApiFollow"  v-if="['IN_PROGRESS','SUCCESS'].includes(repayResult.repayStatus)">
            <guideApiFollow placeEnum="REPAY_SUCCESS"></guideApiFollow>
          </div>
          <div :class="repayResult.repayStatus==='IN_PROGRESS'?'mt200':'mt139'">
            <div v-if="repayResult.repayStatus==='IN_PROGRESS'">
              <div class="benner" v-if="bannerData.desc" @click="goSvip(10408)">{{bannerData.desc}} ></div>
              <nd-button v-show="bannerData.buttonText" :class="['btn small line',{'width690 red':repayResult.repayStatus==='IN_PROGRESS'}]" @click="goSvip(10409)">{{ bannerData.buttonText }}</nd-button>
            </div>
            <nd-button v-show="platform.showButton" :class="['btn small line',{'width320':repayResult.repayStatus==='IN_PROGRESS'}]" @click="backHome" v-showApiBackHome>{{ platform.buttonTitle }}</nd-button>
           
          </div>
        </div>

        <!-- 线下还款 -->
        <div class='repay-status' v-else>
          <div class="animation-wapper" v-if="showGif">
            <lottie ref="animataion" :options="showGif" v-on:animCreated="handleAnimation" />
          </div>
          <p class="status-title" @click="play">{{ platform.name }}</p>

          <div class="status-description">
            <p v-for="(des, index) in platform.des" :key="index">{{ des }}</p>
          </div>

          <div class="bill-info" v-if="repayStatus === 'SUCCESS'">
            <div class="item">
              <p class="title">还款金额</p>
              <p class="content number">￥{{ repayResult.realTotalAmt | currency}}</p>
            </div>
            <div class="item">
              <p class="title">还款日期</p>
              <p class="content number">{{ repayResult.realRepayTime | date}}</p>
            </div>
            <div class="item">
              <p class="title">还款平台</p>
              <p class="content">天美贷</p>
            </div>
          </div>
          <div class="bill-info" v-else-if="repayStatus === 'PART'">
            <div class="item">
              <p class="title">已还款金额</p>
              <p class="content number">￥{{ repayResult.realTotalAmt | currency}}</p>
            </div>
            <div class="item">
              <p class="title">待还款金额</p>
              <p class="content number">￥{{ repayResult.crRepayTotalAmt | currency}}</p>
            </div>
            <div class="item">
              <p class="title">还款日期</p>
              <p class="content number">{{ repayResult.realRepayTime | date}}</p>
            </div>
            <div class="item">
              <p class="title">还款平台</p>
              <p class="content">天美贷</p>
            </div>
          </div>
          <div :class="repayResult.repayStatus==='IN_PROGRESS'?'mt200':'mt139'">
            <div v-if="repayResult.repayStatus==='IN_PROGRESS'">
              <div class="benner" v-if="bannerData.desc" @click="goSvip(10408)">{{bannerData.desc}} ></div>
              <nd-button v-show="bannerData.buttonText" :class="['btn small line',{'width690 red':repayResult.repayStatus==='IN_PROGRESS'}]" @click="goSvip(10409)">{{ bannerData.buttonText }}</nd-button>
            </div>
            <nd-button v-show="platform.showButton" :class="['btn small line',{'width320':repayResult.repayStatus==='IN_PROGRESS'}]" @click="backHome">{{ platform.buttonTitle }}</nd-button>
          </div>

        </div>
      </template>
    </pulldown-page>

    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService" @close="closeDialog">
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="description1">客服电话：4000100008</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>

    <nd-dialog v-model="bVipVisible" @confirm="callService" @close="closeDialog" closeBtn :footer="false">
      <div class="bvip-tips-dialog">
        <div class="title">大权益pro支付</div>
        <div class="description">您存在未支付的消费订单，请前往查看</div>
        <nd-button  class="bvip-tips-btn" @click="check">去支付</nd-button>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { fail, wait, success } from '@/assets/json/index'
import { mapActions } from 'vuex'
import { mockHrefJump, judgeClientSystem, getKey } from '../../assets/utils'
import Lottie from 'vue-lottie'
import guideWithdraw from './components/guide-withdraw/index.vue'

export default {
  name: 'repayment-result',
  customReadyNotify: true,
  components: {
    lottie: Lottie,
    guideWithdraw,
    guideApiFollow: () => import('@/components/guide-api-follow/index.vue')
  },

  data () {
    return {
      showGif: null,
      serviceVisible: false,
      repayResult: {},
      loanPlatform: this.$route.query.loanPlatform || 'YZD',
      termList: this.$storage.get('selectedTerms'),
      repayId: this.$route.query.repayId,
      type: this.$route.query.type,
      orderId: this.$route.query.orderId || '',
      fundCode: this.$route.query.fundCode || '',
      animationSpeed: 1,
      gvipRepayPopupShow: 'N',
      bVipVisible: false,
      timer: false,
      bannerData: {} // 会员banner
    }
  },

  async created () {
    try {
      if (this.isApiH5) {
        const { success, data } = await this.repayResultConfigX({
          billNo: this.orderId
        })
        if (success) {
          this.gvipRepayPopupShow = data.gvipRepayPopupShow
        }
      }
      await this.getRepayResult()
      this.point()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },
  mounted () {
    this.play()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    ...mapActions('repay', [
      'getRepayStatusX',
      'getBusAccX',
      'repayResultBanner',
      'repayResultConfigX'
    ]),
    ...mapActions('vip', ['memberInfo']),
    handleAnimation (anim) {
      console.log('handleAnimation')
      this.anim = anim
    },
    check () {
      this.$router.push('/repayment/history?currentTab=expenseOrder')
    },
    // 埋点
    async point () {
      const { repayStatus, haveRepayConsumptionBill } = this.repayResult || {}
      if (haveRepayConsumptionBill && this.gvipRepayPopupShow === 'N') {
        return
      }
      let data = ''
      if (repayStatus === 'FAIL') {
        data = 'fail'
      } else if (repayStatus === 'IN_PROGRESS') {
        data = 'loading'
      } else {
        data = 'success'
      }

      if (this.gvipRepayPopupShow === 'Y') {
        this.timer = setTimeout(() => {
          this.bVipVisible = true
        }, 1000)
      }
      
      const res = await this.memberInfo()
      let { meetSVIP } = res.data || {}
      if (this.type === 'online') {
        this.$report({
          id: 10002,
          args: {
            screen: 'page_repayment_result',
            status: meetSVIP ? 1 : 0,
            step: data
          }
        })
      } else {
        this.$report({
          id: 10002,
          args: {
            screen: 'page_reconciliations',
            status: meetSVIP ? 1 : 0,
            step: data
          }
        })
      }
    },
    goSvip (id) {
      this.$report({
        id
      })
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let data = `gid=${gid}&token=${token}&position=1`
      const channel = getKey('channel') || ''
      window.location.replace(
        `${process.env.VUE_APP_PAYURL}/vip/ssvip?${data}&channel=${channel}&refurl=${window.location.origin}`
      )
    },
    goWithDraw () {
      if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      } else {
        this.$router.push('/withdraw/index')
      }
    },
    stop () {
      console.log('stop')
      this.anim.stop()
    },

    play () {
      console.log('play')
    },

    pause () {
      console.log('pause')
      this.anim.pause()
    },

    onSpeedChange () {
      this.anim.setSpeed(this.animationSpeed)
    },

    // 下拉刷新
    pulldown () {
      window.location.reload()
    },
    openCallDialog () {
      this.$report({
        id: 10059,
        args: {
          position: this.repayStatus
        }
      })
      this.serviceVisible = true
    },

    async refresh () {
      if (this.type === 'online') {
        await this.getRepayResult()
      } else {
        await Promise.all([this.getBusAcc(), this.getRepayResult()])
      }
      return true
    },
    // 是否展示banner
    async bannerResult () {
      let res = await this.repayResultBanner()
      if (res.success) {
        this.bannerData = res.data || {}
      }
    },
    async getRepayResult () {
      const params = {
        repayId: this.repayId
      }
      const response = await this.getRepayStatusX(params)
      if (response.success) {
        this.repayResult = response.data
        this.bannerResult()
        this.changeGif(this.repayResult.repayStatus || 'IN_PROGRESS')
        this.$sensors.track('parameters_report', { page_status: this.repayResult.repayStatus })
      }
    },
    // 改变图片
    changeGif (value) {
      let title = {}
      if (this.type === 'offline') {
        if (['SUCCESS', 'PART'].includes(value)) {
          title = { animationData: success, loop: false }
        } else if (value === 'FAIL') {
          title = { animationData: fail, loop: false }
        } else if (value === 'IN_PROGRESS') {
          title = { animationData: wait }
        }
      } else {
        if (['SUCCESS', 'PART'].includes(value)) {
          title = { animationData: success, loop: false }
        } else if (value === 'FAIL') {
          title = { animationData: fail, loop: false }
        } else if (value === 'IN_PROGRESS') {
          title = { animationData: wait }
        }
      }
      this.$nextTick(() => {
        this.showGif = title
      })
    },
    closeDialog () {
    
    },

    callService () {
      mockHrefJump(`tel:4000100008`)
    }
   
  },
  computed: {
    repayStatus () {
      return this.repayResult.repayStatus || 'IN_PROGRESS'
    },
    platform () {
      if (this.type === 'offline') {
        if (['PART'].includes(this.repayStatus)) {
          return {
            name: '部分还款成功',
            des: [
              '您可通过银行流水查看还款明细,',
              '也可联系客服查询实际还款信息'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false
          }
        } else if (['SUCCESS'].includes(this.repayStatus)) {
          return {
            name: '本次对账成功',
            des: [
              '您可通过银行流水查看还款明细,',
              '也可联系客服查询实际还款信息'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false
          }
        } else if (this.repayStatus === 'FAIL') {
          return {
            name: '本次对账失败',
            des: ['您可联系客服，咨询详情'],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: true
          }
        } else if (this.repayStatus === 'IN_PROGRESS') {
          return {
            name: '对账处理中',
            des: ['您的对账申请已提交，请耐心等待… '],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false
          }
        }
      } else {
        if (['PART'].includes(this.repayStatus)) {
          return {
            name: '部分还款成功',
            des: ['恭喜还款成功，订单状态稍后更新，请留意查看'],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false
          }
        } else if (['SUCCESS'].includes(this.repayStatus)) {
          return {
            name: '还款成功',
            des: ['恭喜还款成功，订单状态稍后更新，请留意查看'],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false
          }
        } else if (this.repayStatus === 'FAIL') {
          return {
            name: '还款失败',
            des: [
              '抱歉，本次还款失败，请您稍后重新发起还款；',
              '如有疑问, 联系客服。'
            ],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: true
          }
        } else if (this.repayStatus === 'IN_PROGRESS') {
          return {
            name: '还款中',
            des: ['您的还款申请已提交，请耐心等待还款结果', ''],
            showButton: true,
            buttonTitle: '返回首页',
            showTitle: false
          }
        }
      }
    }
  }
}
</script>

<style lang='less'>
@import "../../assets/less/mixin.less";

  @keyframes float_u_d {
    to {transform: scale(1.1);}
  }
.repay-result {
  height: 100%;
  .guideApiFollow {
    margin:20px 30px;
  }
  .contact {
        font-size: 24px;
      }
  .haveRepayConsumptionBill {
    display: flex;
    flex-direction: column;
    height: 100vh;
   
    
    .back {
      float: right;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-decoration: underline;
      text-align: right;
      padding:30px
    }
    h2 {
      font-size: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5fc074;
      line-height: 59px;
      text-align: center;
      margin-top: 100px;
    }

    &>p {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 13px;
      text-align: center;
      padding: 0 30px;
    }

    .tips {
     
      width: 670px;
      height: 409px;
      background: linear-gradient(180deg, #fffcfb 0%, #fff7f6 100%);
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      margin:187px auto 0;
      .bell {
        width: 187px;
        height: 160px;
        background: url(./images/bell.png) no-repeat;
        background-size: 100% 100%;
        margin: -90px auto 0 ;
      }
      .btn {
        width: 440px;
        height: 80px;
        line-height: 80px;
        margin: 20px auto;
        animation: float_u_d 1s infinite alternate;
      }

      h3 {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
      }

      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        padding:30px
      }
    }
  }

  .mt139 {
    margin-top: 139px;
  }

  .mt200 {
    margin-top: 240px;
  }

  .benner {
    width: 690px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    background: #fff2f1;
    border-radius: 14px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff4633;
  }

  .page {
    overflow: auto;
  }

  .call {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    bottom: 92px;
    left: 275px;
    width: 200px;
    height: 60px;
    background: #fafafa;
    border-radius: 40px;
    border: 1px solid #eeeeee;
    padding: 0 23px 0 28px;

    img {
      width: 29px;
      height: 29px;

      span {
        width: 104px;
        height: 37px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 37px;
      }
    }
  }

  .repay-status {
    position: relative;
    text-align: center;
    top: 219px;

    .animation-wapper {
      height: 210px;
      width: 210px;
      margin: 0 auto;
    }

    .image {
      width: 190px;
      height: 190px;
    }

    .status-title {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 59px;
      font-size: 42px;
      margin-top: 51px;
      color: @fc1;
    }

    .status-description {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      line-height: 37px;
      font-size: 26px;
      margin-top: 15px;
      color: @fc2;
    }

    .bill-info {
      padding: 0 30px;
      margin-top: 42px;
      padding-top: 42px;
      margin-left: 42px;
      margin-right: 42px;
      padding-bottom: 20px;
      font-size: 28px;
      text-align: left;
      background-color: #fafafa;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      border-radius: 20px;
      line-height: 50px;

      .item {
        display: flex;
        flex-direction: row;

        .title {
          color: @fc2;
          flex-shrink: 0;
        }

        .content {
          color: @fc1;
          margin-left: 42px;
        }

        .number {
          font-family: DIN-Medium, DIN;
          word-break: break-all;
        }
      }
    }

    .btn {
      margin: 0 auto;
      margin-top: 30px;
    }

    .red {
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      color: #ffffff !important;
    }

    .width690 {
      width: 690px !important;
    }

    .width320 {
      width: 320px !important;
    }
  }

  .bvip-tips-dialog {
    padding: 10px 48px 80px;
    text-align: center;
    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    .description {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }
    .bvip-tips-btn {
      width: 440px;
      height: 80px;
      line-height: 80px;
      font-size: 32px;
      margin: auto;
      margin-top: 65px;
    } 
  }
  .service-dialog {
    padding: 10px 48px 80px;
    font-family: PingFangSC-Regular, PingFang SC;

    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }

    .description {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }

    .description1 {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin: 12px auto 12px;
      font-weight: 400;
    }

    .telphone {
      font-size: 24px;
      height: 40px;
      line-height: 40px;
      margin-top: 2px;
      font-weight: 400;
      color: @fc3;
    }
  }
}
</style>